import * as React from "react";

const ChartPie = (props: any) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path d="M42 17H25V0c9.389 0 17 7.611 17 17z" id="a" />
      <path
        d="M17 8C7.611 8 0 15.611 0 25s7.611 17 17 17 17-7.611 17-17H17V8z"
        id="b"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <g transform="translate(15 7)">
        <use fill="#D2D5D8" xlinkHref="#a" />
        <path
          stroke="#7B838C"
          strokeWidth={4}
          d="M39.868 15C38.978 8.315 33.685 3.023 27 2.132V15h12.868z"
        />
      </g>
      <g strokeLinecap="round" transform="translate(15 7)">
        <use fill="#D2D5D8" xlinkHref="#b" />
        <path
          stroke="#7B838C"
          strokeWidth={4}
          d="M19 23h17v2c0 10.494-8.506 19-19 19S-2 35.494-2 25 6.506 6 17 6h2v17z"
        />
      </g>
    </g>
  </svg>
);

export default ChartPie;

